module.exports = __webpack_public_path__ + "img/afrikai_aktualitasok_orosz-afrikai_csucs.814f6c6d.jpeg";